"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _utils = _interopRequireDefault(require("../utils/utils"));

var _Menu = _interopRequireWildcard(require("../Menu"));

var _TextField = _interopRequireDefault(require("../TextField"));

var _Label = _interopRequireDefault(require("../Label"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Pagination = _interopRequireDefault(require("./Pagination.style"));

var _dec, _class;

const DOTS_START = '...';
const DOTS_END = '...';
let Pagination = (_dec = (0, _reactJss.default)(_Pagination.default), _dec(_class = class Pagination extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      textPage: '',
      perPageMenu: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleRowsPerPageChange = this.handleRowsPerPageChange.bind(this);
    this.handleJumpToPage = this.handleJumpToPage.bind(this);
  }

  getCorrectPage(value, paginationSize) {
    let page = Number(value);
    if (!page) return 0;

    if (page < 1) {
      page = 1;
    } else if (page > paginationSize) {
      page = paginationSize;
    }

    return page;
  } // Замена {range}, {count} в label


  replaceLabelVars(value, count, rowsPerPage, label) {
    let replacedLabel = _utils.default.stripHtml(label); // Дипазон отображаемых элеметов


    if (replacedLabel.includes('{range}')) {
      const rangeStart = (value - 1) * rowsPerPage + 1;
      const rangeEnd = value * rowsPerPage < count ? value * rowsPerPage : count; // выделяем range semibold

      const range = `<span class="range">${rangeStart}-${rangeEnd}</span>`;
      replacedLabel = replacedLabel.replace('{range}', range);
    } // Общее количество элементов


    if (replacedLabel.includes('{count}')) {
      replacedLabel = replacedLabel.replace('{count}', count);
    }

    return replacedLabel;
  } // Создаем элемент пагинации


  makePageElement(itemValue, value) {
    const {
      classes,
      dataTestId
    } = this.props;
    const isDots = itemValue === DOTS_START || itemValue === DOTS_END;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: isDots ? _utils.default.random() : itemValue,
      className: (0, _clsx.default)(classes.item, {
        active: itemValue === value
      }, {
        disabled: !!isDots
      }),
      onClick: () => this.handleChange(itemValue),
      "data-testid": dataTestId && !isDots ? `${dataTestId}-page-${itemValue}` : undefined
    }, itemValue);
  } // Обработчик смены страницы


  handleChange(newPage) {
    const {
      page,
      onPageChange,
      visibility
    } = this.props;
    const pageNumber = parseInt(newPage, 10);

    if (visibility === 'disabled' || !pageNumber || pageNumber === page) {
      return;
    }

    this.setState({
      textPage: ''
    });
    onPageChange(pageNumber);
  } // Обработчик ручного ввода страницы


  handleJumpToPage(newPage, paginationSize) {
    if (newPage < 1 || newPage > paginationSize) {
      this.setState({
        textPage: ''
      });
    } else {
      this.handleChange(newPage);
    }
  } // Handle click on item or icons
  // Page correction should be done outside component


  handleRowsPerPageChange({
    value
  }) {
    const {
      onRowsPerPageChange
    } = this.props;
    onRowsPerPageChange(value);
    this.setState({
      perPageMenu: false
    });
  } // Элемент выбора кол-ва элементов на 1 странице


  renderPerPageSelect() {
    const {
      classes,
      rowsPerPage,
      rowsPerPageOptions
    } = this.props;
    const {
      perPageMenu
    } = this.state;
    if (!rowsPerPageOptions || rowsPerPageOptions.length < 2 || !rowsPerPageOptions.includes(rowsPerPage)) return null;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.selectPerPage
    }, /*#__PURE__*/_react.default.createElement("div", {
      onClick: () => this.setState({
        perPageMenu: !perPageMenu
      })
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.icon, {
        active: !!perPageMenu
      }),
      size: "micro",
      type: "dropdown"
    })), perPageMenu ? /*#__PURE__*/_react.default.createElement(_Menu.default, {
      className: classes.menu,
      onClick: this.handleRowsPerPageChange,
      onClose: () => this.setState({
        perPageMenu: false
      })
    }, rowsPerPageOptions.map(i => /*#__PURE__*/_react.default.createElement(_Menu.MenuItem, {
      key: i,
      label: i,
      value: i,
      activeItem: rowsPerPage,
      rightIcon: i === rowsPerPage ? 'check' : null
    }))) : null);
  } // Render displayed page number input


  renderPageInput(page, paginationSize) {
    const {
      classes,
      pageInput,
      pageInputAutofocus,
      dataTestId
    } = this.props;
    const {
      textPage
    } = this.state;
    if (!pageInput || paginationSize === 1) return null;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.input,
      "data-testid": dataTestId ? `${dataTestId}-input-container` : undefined
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      value: "Page"
    }), /*#__PURE__*/_react.default.createElement(_TextField.default, {
      className: classes.field,
      size: "small",
      bordered: true,
      type: "int",
      value: textPage,
      autoSelect: pageInputAutofocus,
      error: textPage.length && (!parseInt(textPage, 10) || textPage > paginationSize),
      onChange: ({
        value
      }) => this.setState({
        textPage: value
      }),
      onBlur: () => this.handleJumpToPage(textPage, paginationSize),
      onKeyUp: e => {
        if (e.key === 'Enter') this.handleJumpToPage(textPage, paginationSize);
      },
      dataTestId: dataTestId ? `${dataTestId}-input` : undefined
    }));
  } // Формируем элементы пагинации и рендерим


  renderPagination(page, size) {
    const {
      siblingCount,
      boundaryCount
    } = this.props;
    if (!page || !size) return [];

    const startPages = _utils.default.range(1, Math.min(boundaryCount, size));

    const endPages = _utils.default.range(Math.max(size - boundaryCount + 1, boundaryCount + 1), size);

    const siblingsStart = Math.max(Math.min(page - siblingCount, size - boundaryCount - siblingCount * 2 - 1), boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(page + siblingCount, boundaryCount + siblingCount * 2 + 2), endPages.length > 0 ? endPages[0] - 2 : size - 1);
    const items = [...startPages, // eslint-disable-next-line no-nested-ternary
    ...(siblingsStart > boundaryCount + 2 ? [DOTS_START] : boundaryCount + 1 < size - boundaryCount ? [boundaryCount + 1] : []), ..._utils.default.range(siblingsStart, siblingsEnd), // eslint-disable-next-line no-nested-ternary
    ...(siblingsEnd < size - boundaryCount - 1 ? [DOTS_END] : size - boundaryCount > boundaryCount ? [size - boundaryCount] : []), ...endPages];
    return items.map(pageItem => this.makePageElement(pageItem, page));
  }

  render() {
    const {
      classes,
      className,
      visibility,
      page,
      count,
      rowsPerPage,
      label,
      pageInput,
      unspaced,
      dataTestId
    } = this.props;
    const paginationSize = Math.ceil(count / rowsPerPage);
    const corPage = this.getCorrectPage(page, paginationSize);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(className, classes.container, {
        hidden: visibility === 'hidden'
      }, {
        disabled: visibility === 'disabled'
      }, {
        unspaced
      }),
      "data-testid": dataTestId
    }, paginationSize > 0 ? /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.pagination, {
        hidden: count === 0 || corPage === 0
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.iconPrev,
      onClick: () => {
        if (page === 1) return;
        this.handleChange(corPage - 1);
      },
      "data-testid": dataTestId ? `${dataTestId}-prev` : undefined
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.icon, {
        disabled: page === 1
      }),
      size: "small",
      type: "arrow",
      color: "currentColor"
    })), this.renderPagination(page, paginationSize), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.iconNext,
      onClick: () => {
        if (corPage === paginationSize) return;
        this.handleChange(corPage + 1);
      },
      "data-testid": dataTestId ? `${dataTestId}-next` : undefined
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.icon, {
        disabled: corPage === paginationSize
      }),
      size: "small",
      type: "arrow",
      color: "currentColor"
    })), pageInput ? this.renderPageInput(page, paginationSize) : null) : null, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.label,
      dangerouslySetInnerHTML: {
        __html: this.replaceLabelVars(page, count, rowsPerPage, label)
      }
    }), this.renderPerPageSelect());
  }

}) || _class);
Pagination.defaultProps = {
  visibility: 'visible',
  value: '1',
  onRowsPerPageChange: () => {},
  label: '{range} of {count}',
  siblingCount: 1,
  boundaryCount: 1,
  pageInputAutofocus: true
};
var _default = Pagination;
exports.default = _default;